<template>
  <div class="chart-component-wrap">
    <div
      :id="container"
      class="chart-wrap"
      :style="{ height: chartHeight + 'px' }"
    />
  </div>
</template>

<script>
import DataSet from '@antv/data-set'
import { Chart } from '@antv/g2'
import { getPlace } from '@U/utilTool'

export default {
  name: 'Chart',
  props: {
    type: { // 图表类型
      type: String,
      default: 'trend'
    },
    autoFit: { // 是否自适应显示
      type: Boolean,
      default: true
    },
    chartWidth: {
      type: Number,
      default: 800
    },
    chartHeight: {
      type: Number,
      default: 400
    },
    padding: { // 图表间距，上右下左
      type: [Array, String],
      default: () => ([20, 10, 10, 0])
    },
    container: { // 图表id
      type: String,
      default: 'tsChart'
    },
    shared: { // 是否对一个分组内的数组进行对比显示
      type: Boolean,
      default: true
    },
    showMarkers: { // 是否展示 tooltip markers, 汇总图表一般不显示
      type: Boolean,
      default: false
    },
    showCrosshairs: { // 是否展示 Tooltip 辅助线
      type: Boolean,
      default: true
    },
    xAxis: { // x轴文本名称
      type: String,
      default: 'date'
    },
    yAxis: { // y轴文本名称
      type: String,
      default: 'total'
    },
    tickCount: { // 期望的 tick 数量
      type: Number,
      default: 10
    },
    nice: { // 数值友好，用来调整min&max
      type: Boolean,
      default: true
    },
    color: { // 线的颜色
      type: String,
      default: 'name'
    },
    size: { // 线的宽度
      type: Number,
      default: 4
    },
    lineShape: { // 线图图形
      type: String,
      default: 'smooth'
    },
    pointShape: {
      type: String,
      default: 'circle'
    },
    areaShape: { // 线图图形
      type: String,
      default: 'smooth'
    },
    showArea: { // 是否显示区域图形
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    tooltip: { // 单独为特殊的提示配置
      type: String,
      default: ''
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    autoEllipsis: {
      type: Boolean,
      default: true
    },
    autoRotate: {
      type: Boolean,
      default: false
    },
    verticalLimitLength: {
      type: Number,
      default: 60
    }
  },
  methods: {
    clearDiv() {
      if (this.chartData && !this.chartData.destroyed) {
        this.chartData.destroy()
        this.chartData.clear()
      }
    },
    initChart(data) {
      this.clearDiv()
      // this.chartData && this.chartData.destroy()
      if (!data || !data.length) {
        return
      }
      const { DataView } = DataSet
      const dv = new DataView().source(data)
      this.chartData = new Chart({
        container: this.container,
        autoFit: this.autoFit,
        padding: 'auto',
        appendPadding: this.padding
      })
      this.chartData.data(dv.rows)
      this.chartData.tooltip({
        shared: this.shared,
        showCrosshairs: this.showCrosshairs
      })

      this.configTooltip()

      this.chartData.scale(this.xAxis, {
        tickCount: this.tickCount
      })
      this.chartData.scale(this.yAxis, {
        nice: this.nice,
        min: this.min
      })
      this.chartData.axis(this.xAxis, {
        label: {
          autoHide: this.autoHide,
          autoEllipsis: this.autoEllipsis,
          autoRotate: this.autoRotate
        },
        verticalLimitLength: this.verticalLimitLength
      })
      this.chartData.axis(this.yAxis, {
        grid: null,
        label: {
          formatter: function formatter(text) {
            return text.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
          }
        }
      })
      switch (this.type) {
        case 'trend':
          this.chartData
            .line()
            .position(`${this.xAxis}*${this.yAxis}`)
            .color(this.color)
            .shape(this.lineShape)

          if (this.showArea) {
            this.chartData
              .area()
              .position(`${this.xAxis}*${this.yAxis}`)
              .color(this.color)
              .shape(this.areaShape)
          }

          this.chartData
            .point()
            .position(`${this.xAxis}*${this.yAxis}`)
            .color(this.color)
            .shape(this.pointShape)
          break
      }
      this.chartData.render()
    },
    configTooltip() {
      // 是否单独配置tooltip, 根据传入的tooltip字段进行个性化配置显示, 不传则默认配置
      if (!this.tooltip) {
        return
      }
      this.chartData.on('tooltip:show', ev => {
        const items = ev.items || ev.data.items
        switch (this.tooltip) {
          case 'page':
          case 'landing':
          case 'channelLink':
            items.forEach(item => {
              item.value = item.name === '跳出率' || item.name === '退出率' ? `${item.value}%` : getPlace(item.value)
            })
            break
          case 'funnel':
            items.forEach(item => {
              item.name = item.name ? item.name : this.$t('analysis.entire')
              item.value = item.value ? (getPlace(item.value) + '%') : '0%'
            })
            break
          case 'dashboard':
            items.forEach(item => {
              item.value = getPlace(item.value)
            })
            break
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-component-wrap {
  .chart-wrap {
    width: 100%;
  }
}
</style>
